"use client";

import { cn } from "@/lib/utils/utils";

interface CircleIconProps {
  icon: React.ReactNode;
  className?: string;
}

const CircleIcon: React.FC<CircleIconProps> = ({ icon, className }) => {
  return (
    <div
      className={cn(
        "flex items-center justify-center rounded-full h-8 w-8 bg-primary text-white",
        className
      )}
    >
      {icon}
    </div>
  );
};

export default CircleIcon;
